import angular from 'angular'
//import ActivityEdit from 'emun.activity/activity-edit'
import BlogList from 'emun.blog/blog-list'
import BlogBanner from 'emun.blog/blog-banner'
import BlogNotify from 'emun.blog/blog-notify'
import scss from 'emun.blog/emun-blog.scss'

const dependencies = ['emun.auth','webutils', 'webforms', 'webmodals', 'ui.router'];

export default angular.module('emun.blog', dependencies)
	.component('blogList', BlogList)
	.component('blogBanner', BlogBanner)
	.component('blogNotify', BlogNotify)
	.name;